// import Head from "next/head";
// import Image from "next/image";
import styles from "../styles/Page.module.css";
import { Link } from "react-router-dom";

import React, { FC, ReactNode } from "react";

interface Props {
    children: ReactNode;
    href: string;
    style?: React.CSSProperties;
}

const Page: React.FC<Props> = ({ style: stylesProp = {}, children, href }) => {
    const rawPage: string = window.location.pathname.split("/")[1];
    // const page: string | null = rawPage === "math150" ? "calc" : rawPage === "math254" ? "lindisc" : "calc";

    return (
        <main className={`${styles.main}`}>
            <p
                style={{
                    position: "absolute",
                    top: "25px",
                    right: "25px",
                    zIndex: -9999,
                    fontSize: "12.5px",
                }}
            >
                {rawPage === "math254" ? "Math 254/245" : "Math 150/151"}
            </p>

            <div className={styles.navBar}>
                <Link to={`/`}>
                    <div className={`material-icons ${styles.navButton}`}>
                        home
                    </div>
                </Link>
                <Link to={`/${rawPage}/`}>
                    <div className={styles.navButton}>Announcements</div>
                </Link>
                <Link to={`/${rawPage}/units`}>
                    <div className={styles.navButton}>Units</div>
                </Link>
                {/* <Link to={`/${href}/assignments`}>
                    <div className={styles.navButton}>Assignments</div>
                </Link> */}
                <Link to={`/${rawPage}/calendar`}>
                    <div className={styles.navButton}>Calendar</div>
                </Link>
            </div>

            <div className={styles.content}>
                <div
                    style={{
                        padding: "0px",
                        margin: "0px",
                        // width: "100%",
                        // height: "100%",
                        ...stylesProp,
                    }}
                >
                    {children}
                </div>
            </div>

            {/* <footer className={styles.footer}>
                    <a href="mailto:" target="_blank" rel="noopener noreferrer">
                        Website Created by Asher Grusd, Contact *@gmail.com
                        about the site if any bug occurs.
                    </a>
                </footer> */}
        </main>
    );
};

export default Page;
